<template>
  <div class="app-wrapper" v-bind:class="{ closed: menu_opened }">

    <SideNavigation @menu-toggled="menu_toggled"/>

    <div class="wrapper">
      <TopNavigation />
      <Entity />

      <div class="input-group label">
        <label> No. of unit </label>
        <input type="text" placeholder="Enter unit">
        <span class="iconify icon icon:ant-design:field-number-outlined"></span>
      </div>

      <div class="input-group label">
        <label> Quantity </label>
        <div class="row">
          <input type="number" placeholder="Enter amount" class="no-icon">
          <div class="radio-wrapper">
            <label>
              <div class="radio-container">
                <input type="radio" name="quantity" checked>
                <span> Square metre </span>
              </div>
            </label>

            <label>
              <div class="radio-container">
                <input type="radio" name="quantity">
                <span> Monthly </span>
              </div>
            </label>

            <label>
              <div class="radio-container">
                <input type="radio" name="quantity">
                <span> Annual </span>
              </div>
            </label>
          </div><!-- end of radio-wrapper -->
        </div>
      </div>

      <div class="input-group label">
        <label> Rent price </label>
        <div class="row">
          <div>
            <input type="number" placeholder="Enter amount" class="no-icon">
            <select class="currency">
              <option value="rsd" selected> RSD </option>
              <option value="euro"> EUR </option>
              <option value="dolar"> USD </option>
            </select>
          </div>
          <div class="radio-wrapper">
            <label>
              <div class="radio-container">
                <input type="radio" name="rent_price" checked>
                <span> Square metre </span>
              </div>
            </label>

            <label>
              <div class="radio-container">
                <input type="radio" name="rent_price">
                <span> Monthly </span>
              </div>
            </label>

            <label>
              <div class="radio-container">
                <input type="radio" name="rent_price">
                <span> Annual </span>
              </div>
            </label>
          </div><!-- end of radio-wrapper -->
        </div><!-- end of row -->
      </div><!-- end of input-group -->

      <div class="input-group label">
        <label> Step up rent </label>
        <select v-model="step_up_rent">
          <option value="no" selected> No </option>
          <option value="yes"> Yes </option>
        </select>
      </div><!-- end of input-group -->

      <div class="step-up-rent-wrapper toggle-wrapper" v-if="step_up_rent == 'yes'">
        <div class="input-group label">
          <label> Beginning of period </label>
          <input type="date">
          <span class="iconify icon icon:mdi:calendar-edit"></span>
        </div><!-- end of input-group -->

        <div class="input-group label">
          <label> End of period </label>
          <input type="date">
          <span class="iconify icon icon:mdi:calendar-clock"></span>
        </div><!-- end of input-group -->

        <div class="input-group label">
          <label> Rent price </label>
          <div class="row">
            <div>
              <input type="number" placeholder="Enter amount" class="no-icon">
              <select class="currency">
                <option value="rsd" selected> RSD </option>
                <option value="euro"> EUR </option>
                <option value="dolar"> USD </option>
              </select>
            </div>
          </div><!-- end of row -->
        </div><!-- end of input-group -->
      </div><!-- end of step-up-rent-wrapper -->

      <div class="input-group label">
        <label> Frequency of rent payments </label>
        <select>
          <option value="0" selected disabled> Select ... </option>
          <option value="weekly"> Weekly </option>
          <option value="monthly"> Monthly </option>
          <option value="quartally"> Quartally </option>
          <option value="semi-annual"> Semi-annual </option>
          <option value="annual"> Annual </option>
        </select>
      </div><!-- end of input-group -->

      <div class="input-group label">
        <label> Timing of rent payments </label>
        <select>
          <option value="0" selected disabled> Select ... </option>
          <option value="beginning"> Beginning of period </option>
          <option value="end"> End of period </option>
        </select>
      </div><!-- end of input-group -->

      <div class="input-group label">
        <label> Rent free period </label>
        <select v-model="rent_free">
          <option value="no" selected> No </option>
          <option value="yes"> Yes </option>
        </select>
      </div><!-- end of input-group -->

      <div class="rent-free-wrapper toggle-wrapper" v-if="rent_free == 'yes'">
        <div class="input-group label">
          <label> Beginning of period </label>
          <input type="date">
          <span class="iconify icon icon:mdi:calendar-edit"></span>
        </div><!-- end of input-group -->

        <div class="input-group label">
          <label> End of period </label>
          <input type="date">
          <span class="iconify icon icon:mdi:calendar-clock"></span>
        </div><!-- end of input-group -->
      </div><!-- end of rent-free-wrapper -->

      <div class="input-group label">
        <label> Rent reduction period </label>
        <select v-model="rent_reduction">
          <option value="no" selected> No </option>
          <option value="yes"> Yes </option>
        </select>
      </div><!-- end of input-group -->

      <div class="rent-reduction-wrapper toggle-wrapper" v-if="rent_reduction == 'yes'">
        <div class="input-group label">
          <label> Beginning of period </label>
          <input type="date">
          <span class="iconify icon icon:mdi:calendar-edit"></span>
        </div><!-- end of input-group -->

        <div class="input-group label">
          <label> End of period </label>
          <input type="date">
          <span class="iconify icon icon:mdi:calendar-clock"></span>
        </div><!-- end of input-group -->

        <div class="input-group label">
          <label> Rent price </label>
          <div class="row">
            <div>
              <input type="number" placeholder="Enter amount" class="no-icon">
              <select class="currency">
                <option value="rsd" selected> RSD </option>
                <option value="euro"> EUR </option>
                <option value="dolar"> USD </option>
              </select>
            </div>
          </div><!-- end of row -->
        </div><!-- end of input-group -->
      </div>
      <!--- end of rent-reduction-wrapper -->

      <div class="input-group label">
        <label> Turnover rent </label>
        <select>
          <option value="0" selected disabled> Select ... </option>
          <option value="weekly"> Weekly </option>
          <option value="monthly"> Monthly </option>
          <option value="quartally"> Quartally </option>
          <option value="semi-annual"> Semi-annual </option>
          <option value="annual"> Annual </option>
        </select>
      </div><!-- end of input-group -->

      <div class="input-group label">
        <label> Turnover </label>
        <div class="row icons">
          <input type="number" placeholder="Enter amount" class="no-icon">
          <span> % </span>
        </div><!-- end of row -->
      </div><!-- end of input-group -->

      <div class="input-group label">
        <label> Turnover calculation period </label>
        <select>
          <option value="0" selected disabled> Select ... </option>
          <option value="weekly"> Weekly </option>
          <option value="monthly"> Monthly </option>
          <option value="quartally"> Quartally </option>
          <option value="semi-annual"> Semi-annual </option>
          <option value="annual"> Annual </option>
        </select>
      </div><!-- end of input-group -->

      <div class="input-group label">
        <label> Turnover invoicing period </label>
        <select>
          <option value="0" selected disabled> Select ... </option>
          <option value="weekly"> Weekly </option>
          <option value="monthly"> Monthly </option>
          <option value="quartally"> Quartally </option>
          <option value="semi-annual"> Semi-annual </option>
          <option value="annual"> Annual </option>
        </select>
      </div><!-- end of input-group -->

      <div class="input-group label">
        <label> Service Charge / Operation cost </label>
        <div class="row">
          <div>
            <input type="number" placeholder="Enter amount" class="no-icon">
            <select class="currency">
              <option value="rsd" selected> RSD </option>
              <option value="euro"> EUR </option>
              <option value="dolar"> USD </option>
            </select>
          </div>
          <div class="radio-wrapper">
            <label>
              <div class="radio-container">
                <input type="radio" name="service_charge" checked>
                <span> Square metre </span>
              </div>
            </label>

            <label>
              <div class="radio-container">
                <input type="radio" name="service_charge">
                <span> Monthly </span>
              </div>
            </label>

            <label>
              <div class="radio-container">
                <input type="radio" name="service_charge">
                <span> Annual </span>
              </div>
            </label>
          </div><!-- end of radio-wrapper -->
        </div><!-- end of row -->
      </div><!-- end of input-group -->

      <div class="input-group label">
        <label> Frequency of SC payments </label>
        <select>
          <option value="0" selected disabled> Select ... </option>
          <option value="weekly"> Weekly </option>
          <option value="monthly"> Monthly </option>
          <option value="quartally"> Quartally </option>
          <option value="semi-annual"> Semi-annual </option>
          <option value="annual"> Annual </option>
        </select>
      </div><!-- end of input-group -->

      <div class="input-group label">
        <label> Timing of SC payments </label>
        <select>
          <option value="0" selected disabled> Select ... </option>
          <option value="begining"> Begining of period </option>
          <option value="end"> End of period </option>
        </select>
      </div><!-- end of input-group -->

      <div class="input-group label">
        <label> Open book policy </label>
        <select>
          <option value="no" selected> No </option>
          <option value="yes"> Yes </option>
        </select>
      </div><!-- end of input-group -->

      <div class="input-group label">
        <label> Marketing Charge </label>
        <div class="row">
          <div>
            <input type="number" placeholder="Enter amount" class="no-icon">
            <select class="currency">
              <option value="rsd" selected> RSD </option>
              <option value="euro"> EUR </option>
              <option value="dolar"> USD </option>
            </select>
          </div>
          <div class="radio-wrapper">
            <label>
              <div class="radio-container">
                <input type="radio" name="marketing_charge" checked>
                <span> Square metre </span>
              </div>
            </label>

            <label>
              <div class="radio-container">
                <input type="radio" name="marketing_charge">
                <span> Monthly </span>
              </div>
            </label>

            <label>
              <div class="radio-container">
                <input type="radio" name="marketing_charge">
                <span> Annual </span>
              </div>
            </label>
          </div><!-- end of radio-wrapper -->
        </div><!-- end of row -->
      </div><!-- end of input-group -->

      <div class="input-group label">
        <label> Frequency of Marketing payments </label>
        <select>
          <option value="0" selected disabled> Select ... </option>
          <option value="weekly"> Weekly </option>
          <option value="monthly"> Monthly </option>
          <option value="quartally"> Quartally </option>
          <option value="semi-annual"> Semi-annual </option>
          <option value="annual"> Annual </option>
        </select>
      </div><!-- end of input-group -->

      <div class="input-group label">
        <label> Timing of Marketing payments </label>
        <select>
          <option value="0" selected disabled> Select ... </option>
          <option value="begining"> Begining of period </option>
          <option value="end"> End of period </option>
        </select>
      </div><!-- end of input-group -->

      <div class="controls">
        <button class="step" @click="$router.push('basic-info')"> Previous step </button>
        <button class="step" @click="$router.push('security-instruments')"> Next step </button>
      </div>

    </div>
  </div>


</template>

<script>
  import TopNavigation from '@/components/navigation/Top_navigation'
  import SideNavigation from '@/components/navigation/Side_navigation'
  import Entity from '../../components/form/Entity'

  export default {
    components: {
      TopNavigation,
      SideNavigation,
      Entity
    },
    data() {
      return {
        menu_opened: false,
        step_up_rent: 'no',
        rent_free: 'no',
        rent_reduction: 'no',
      }
    },
    methods: {
      menu_toggled() {this.menu_opened = !this.menu_opened} 
    }
  }
</script>

<style scoped>
  .controls {
    display: flex;
    justify-content: center;
    margin-top: 40px;
  }

  .step {
    width: fit-content;
    margin: 20px auto;
    padding: 15px 35px;
  }
</style>